









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class UiIconComponent extends Vue {
  @Prop()
  public icon: string;

  @Prop({default: false})
  public dashboardTag: boolean;

  private hasText(): boolean {
    return !!this.$slots.default;
  }
}
